"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _withContainer = require("./withContainer");

var _withContainer2 = _interopRequireDefault(_withContainer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SvgRightarrowSecondary = function SvgRightarrowSecondary(props) {
    return _react2.default.createElement(
        "svg",
        Object.assign({ width: "1em", height: "1em", viewBox: "0 0 32 32" }, props),
        _react2.default.createElement("path", {
            d: "M3.88 14.8H25l-6.66-6.06A1.202 1.202 0 0120 7l9 8.14c.034.051.064.105.09.16a1.4 1.4 0 01.1.16v.05a1.6 1.6 0 01.05.21 1.25 1.25 0 010 .19.65.65 0 010 .19c.01.07.01.14 0 .21v.06a.6.6 0 01-.09.13v.05s-.05.09-.09.14v.05L20 25a1.16 1.16 0 01-.8.32 1.21 1.21 0 01-.89-.4 1.19 1.19 0 01.08-1.69L25 17.2H3.88a1.2 1.2 0 110-2.4z",
            fill: "currentColor",
            fillRule: "nonzero"
        })
    );
};

exports.default = (0, _withContainer2.default)(SvgRightarrowSecondary);